// extracted by mini-css-extract-plugin
module.exports = {"partnershipBeginContainer":"PartnershipInformation_partnershipBeginContainer__2GHJ_"};